import VersionTag from './VersionTag';
import './VersionTag.css';

export default VersionTag;


// WEBPACK FOOTER //
// ./src/shared/components/VersionTag/index.js